<template>
    <section class="inner-content">
        <b-message v-if="error" type="is-danger">Something went wrong, please refresh the page</b-message>

        <search-form v-if="searchable" @searching="searching"></search-form>

        <b-table :data="items"
                 :total="total"
                 :current-page="currentPage"
                 :per-page="perPage"
                 :loading="loading"
                 :row-class="(row) => row.is_active==1 && 'is-active-season'"
                 paginated
                 backend-pagination
                 striped bordered :checkable="checkable" :checked-rows.sync="checkedRows"
                 @page-change="changePage">
            <b-table-column v-for="column in columns" :key="column.field" :id="column.field" :label="column.label" :centered="column.centered" v-slot="props">
                <table-actions v-if="column.field === 'actions'" :actions="column.actions" :item="props.row" :model="model"></table-actions>
                <a v-if="column.field === 'url'" v-bind:href="props.row[column.field]"> {{ props.row.name }} </a>
                <span v-else>
                    {{ Array.isArray(props.row[column.field])?
                        joinArrayValues(props.row[column.field]) :
                        props.row[column.field] }}
                </span>
            </b-table-column>
        </b-table>
        <b-button v-if="checkable"
                  tag="button"
                  type="is-primary"
                  class="is-uppercase mt-3"
                  label='Save'
                  outlined rounded style="margin-left: auto"
                  @click.prevent="setActiveSeason"/>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            type: [Array, Object]
        },
        columns: {
            required: true,
            type: Array
        },
        model: {
            required: true,
            type: String
        },
        searchable: {
            required: false,
            type: Boolean,
            default: false
        },
        tableShouldLoad: {
            required: false,
            type: Boolean,
            default: false
        },
        paginationEndpoint: {
            required: false,
            type: String
        },
        paginationRoute: {
            required: true,
            type: String
        },
        useNamedRoute: {
            required: false,
            type: Boolean,
            default: false
        },
        checkable: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            paging: {
                url: null,
                query: null
            },
            items: this.data.data,
            total: this.data.total,
            currentPage: this.data.current_page,
            perPage: this.data.per_page,
            loading: false,
            error: false,
            checkedRows: []
        };
    },
    created() {
        this.loading = this.tableShouldLoad;
    },
    methods: {
        changePage(target) {
            let route = this.useNamedRoute ?
                {name: this.paginationRoute, query: {page: target}} :
                {path: this.paginationRoute, query: {page: target}};

            this.$router.push(route)
        },
        searching(searchTerm) {
            let route = this.useNamedRoute ?
                {name: this.paginationRoute, query: {page: 1, search: searchTerm}} :
                {path: this.paginationRoute, query: {page: 1, search: searchTerm}};

            this.$router.push(route);
        },
        getItems(query) {
            if (!this.paginationEndpoint) return;

            this.loading = true;
            query.paginate = true;
            axios.get(this.paginationEndpoint, {params: query})
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                })
                .catch(response => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                    window.scrollTo({top: 0, behavior: 'smooth'})
                })
        },
        joinArrayValues(array) {
            return array.join(', ');
        },
        setActiveSeason() {
            axios.put(this.paginationEndpoint, {body: {rows: this.checkedRows}}).then(function (response) {
                alert(response.data);
                document.location.reload(true);
            })
        }
    },
    watch: {
        data() {
            this.items = this.data.data;
            this.total = this.data.total;
            this.currentPage = this.data.current_page;
            this.perPage = this.data.per_page;
            this.checkedRows = this.items.filter((el)=>{return el.is_active==1});
        },
        tableShouldLoad(tableShouldLoad) {
            this.loading = tableShouldLoad;
        },
        $route(to, from) {
            this.getItems(to.query)
        },
        checkedRows: {
            deep: true,
            handler() {
                this.$emit('update:checkedRows', this.checkedRows)
            }
        }
    }
}
</script>
